import {
	AccountTree as AccountTreeIcon,
	FilterList as FilterListIcon,
	Inventory2 as Inventory2Icon,
	Label as LabelIcon,
	Timeline as TimelineIcon,
} from "@mui/icons-material";
import React from "react";
import DashboardGuidedTour from "./DashboardGuidedTour";

/**
 * Series Tracking Dashboard guided tour.
 *
 * Thin configuration wrapper around the reusable {@link DashboardGuidedTour}
 * component, which provides the shared Welcome screen, dark-navy tooltip,
 * progress bar, overlay and Previous / Next / Skip Tour / Pause / Close
 * behaviour (the same architecture used by the Vehicle Tracking and Supply
 * Type Allocation dashboard guides).
 *
 * Flow: Welcome screen -> NEXT -> Total Parts -> Workflow Stages ->
 * Status Types -> Filters -> Complete.
 */
const WELCOME = {
	icon: <TimelineIcon sx={{ color: "#cc0000" }} />,
	title: "Series Tracking Tour",
	description:
		"Welcome to the Series Tracking dashboard - your tool for monitoring part progression through different production stages and tracking their current status.",
	footer:
		"This tour will guide you through all key features in about 2 minutes.",
	chips: [
		{
			icon: <FilterListIcon />,
			label: "Advanced Filtering",
			bgcolor: "#e3f2fd",
		},
		{ icon: <AccountTreeIcon />, label: "Workflow Stages", bgcolor: "#e8f5e8" },
		{ icon: <LabelIcon />, label: "Status Types", bgcolor: "#fff3e0" },
		{ icon: <Inventory2Icon />, label: "Parts Overview", bgcolor: "#fce4ec" },
	],
};

const STEPS = [
	{
		target: '[data-tour-target="series-dash-total-parts"]',
		icon: <Inventory2Icon sx={{ color: "#cc0000" }} />,
		title: "Total Parts",
		description: "Shows the total number of parts currently in series production.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="series-dash-workflow-stages"]',
		icon: <AccountTreeIcon sx={{ color: "#cc0000" }} />,
		title: "Workflow Stages",
		description:
			"Shows the number of workflow stages displayed in the Series Tracking chart.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="series-dash-status-types"]',
		icon: <LabelIcon sx={{ color: "#cc0000" }} />,
		title: "Status Types",
		description:
			"Shows the number of different status types used to track part progression.",
		placement: "bottom",
	},
	{
		target: '[data-tour-target="series-dash-filters"]',
		icon: <FilterListIcon sx={{ color: "#cc0000" }} />,
		title: "Filters",
		description:
			"Use these filters to narrow down the series tracking data. Reset clears the selected filters and Apply updates the results. The Floating control can be used to toggle the chart's floating behavior.",
		extra: {
			heading: "Filter Options:",
			text: "• Projects • ALG • Change No. • Reset • Apply • Floating: On/Off",
		},
		placement: "bottom-end",
	},
];

const SeriesTrackingDashboardJoyrideTour = ({ isOpen, onClose }) => (
	<DashboardGuidedTour
		isOpen={isOpen}
		onClose={onClose}
		tourTitle="Series Tracking Tour"
		welcome={WELCOME}
		steps={STEPS}
	/>
);

export default SeriesTrackingDashboardJoyrideTour;
